import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  gap: 20px;
`;

